import { DiscountType } from '@/redux/data/dataTypes';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DiscountList from './DiscountList';

interface DiscountListWithWrapperProps {
  onItemPress?: (item: DiscountType) => void;
  layout?: 'grid' | 'compact';
}

const DiscountListWithWrapper: FC<DiscountListWithWrapperProps> = ({
  onItemPress,
  layout = 'grid',
}) => {
  const { t } = useTranslation();
  const [searchTxt, setSearchTxt] = useState('');

  return (
    <div className="flex flex-col flex-1">
      <div className="flex items-center gap-2.5 mb-4 p-2.5 bg-[#f6f8fc] dark:bg-gray-700 rounded-xl shadow-sm">
        <div className="flex-1 relative">
          <SearchOutlined className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-300 text-sm" />
          <Input
            className="flex-1 bg-white dark:bg-gray-600 border border-gray-200 dark:border-gray-500 min-h-[36px] pl-9 rounded-lg text-gray-800 dark:text-white shadow-sm focus:shadow-md transition-shadow duration-200 text-sm"
            placeholder={t('common:type_something')}
            value={searchTxt}
            onChange={(e) => setSearchTxt(e.target.value)}
          />
        </div>
      </div>
      <div className="flex-1">
        <DiscountList
          searchTxt={searchTxt}
          onItemPress={onItemPress}
          layout={layout}
          listContentClassName="p-1.5"
        />
      </div>
    </div>
  );
};

export default DiscountListWithWrapper;
